var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kanban-board" },
    [
      _c("div", { staticClass: "scroll-indicator" }, [
        _c("div", {
          staticClass: "scroll-bar",
          style: {
            width: _vm.scrollBarWidth + "px",
            left: _vm.scrollBarPosition + "px",
          },
          on: { mousedown: _vm.startDragging },
        }),
      ]),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "supsis-draggable",
          attrs: { options: _vm.taskGroupDragOptions },
          on: {
            start: function () {
              return (_vm.moving = true)
            },
            end: _vm.movePipelineEnd,
          },
          model: {
            value: _vm.groups,
            callback: function ($$v) {
              _vm.groups = $$v
            },
            expression: "groups",
          },
        },
        [
          _c(
            "transition-group",
            { staticClass: "drag-container", attrs: { tag: "div" } },
            _vm._l(_vm.groups, function (item) {
              return _c("TaskColumnCard", {
                key: item._id,
                attrs: {
                  pipeline: item,
                  moving: _vm.moving,
                  "workflow-id": _vm.workflowId,
                },
                on: {
                  moved: _vm.moveActionEnd,
                  "move-back": _vm.getListCard,
                  "pipeline-form": _vm.createPipelineForm,
                  "delete-pipeline": _vm.deletePipeline,
                  "create-pipeline": _vm.createPipeline,
                  "update-pipeline": _vm.updatePipeline,
                  "delete-modal-task": _vm.openDeleteTaskModal,
                  "confirm-modal-task": _vm.confirmModalOpen,
                  "archived-modal-task": _vm.archivedModalOpen,
                  "change-workflow-task": _vm.changeWorkflowTask,
                  "to-completed-task": _vm.toCompletedTask,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.deleteTaskModal
        ? _c("DeleteModal", {
            attrs: {
              description: _vm.$t("task.deleteTaskCont"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.delete"),
            },
            on: {
              cancel: function ($event) {
                _vm.deleteTaskModal = false
              },
              confirm: _vm.softDeleteTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmTaskModal
        ? _c("ConfirmModal", {
            attrs: {
              description: _vm.$t("task.sureAddCompletedList"),
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.yes"),
            },
            on: {
              cancel: function ($event) {
                _vm.confirmTaskModal = false
              },
              confirm: _vm.confirmTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.archivedTaskModal
        ? _c("TaskArchiveModal", {
            attrs: {
              description: "Görevi Arşivlemek İstediğinize Emin Misiniz?",
              btnCancelText: _vm.$t("message.cancel"),
              btnoktext: _vm.$t("message.yes"),
            },
            on: {
              cancel: function ($event) {
                _vm.archivedTaskModal = false
              },
              confirm: _vm.archiveModalTask,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: { title: "Change Workflow" },
          on: { ok: _vm.handleChangeWorkflow, cancel: _vm.handleCancel },
          model: {
            value: _vm.changeWorkflowModal,
            callback: function ($$v) {
              _vm.changeWorkflowModal = $$v
            },
            expression: "changeWorkflowModal",
          },
        },
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "Select a workflow" },
              model: {
                value: _vm.selectedWorkflow,
                callback: function ($$v) {
                  _vm.selectedWorkflow = $$v
                },
                expression: "selectedWorkflow",
              },
            },
            _vm._l(_vm.workflows, function (workflow) {
              return _c(
                "a-select-option",
                { key: workflow._id, attrs: { value: workflow._id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(workflow.title) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }